module.exports = __webpack_public_path__ + "static/foday-dumbuya-7acf49f4053c830ba1ef7ee1241ab6c4.jpg";